import { inject } from 'mobx-react';
import { ChatDrawerComponent } from './component';
export const ChatDrawer = inject(({ ui }) => ({
    chatMfeUrl: ui.chatMfeUrl,
    chatMfeReady: ui.chatMfeReady,
    registerChatWindow: ui.registerChatWindow,
    unregisterChatWindow: ui.unregisterChatWindow,
}))(ChatDrawerComponent);
//# sourceMappingURL=index.js.map